<template>
  <ContentDisplay
    class="portability-card"
    :blocks-length="2"
    footer-type="navigation"
    :footer-label="portability.actionLabel"
    :footer-href="footerHref"
  >
    <template #content-block-1>
      <HeadingDisplay
        :title="portability.title"
        :subtitle="portability.custodian.name"
        size="small"
        avatar-type="char"
        :avatar-content="custodianInitialChar"
      />
    </template>
    <template #content-block-2>
      <ListDisplay
        v-for="(item, index) in portability.details"
        :key="index"
        class="portability-card__item"
        :title="item.label"
        :value="item.value"
      />
    </template>
  </ContentDisplay>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ContentDisplay,
  HeadingDisplay,
  ListDisplay
} from '@warrenbrasil/nebraska-web';

import { PortabilityRequest } from '@/modules/trade/services/portability';

interface Props {
  portability: PortabilityRequest;
}
const props = defineProps<Props>();

const router = useRouter();

const custodianInitialChar = computed(() => {
  return props.portability.custodian.name[0];
});

const footerHref = computed(() => {
  return router.resolve({
    name: 'portabilityRequestDetails',
    params: { id: props.portability.id }
  }).href;
});
</script>

<style lang="less" scoped>
.portability-card {
  &__item:not(:first-child) {
    padding-top: @size-spacing-x350;
  }
}
</style>
